/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|modules|krannich-c-order-template|components|add-order-template-to-cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-add-order-template-to-cart' */
                'partner/modules/krannich-c-order-template/components/add-order-template-to-cart.component.tsx'),
            cn: '__local__-__local__-add-order-template-to-cart'
        };
componentDictionary['__local__|__local__|modules|krannich-c-search-result-container|components|custom|productListView'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-productListView' */
                'partner/modules/krannich-c-search-result-container/components/custom/productListView.component.tsx'),
            cn: '__local__-__local__-productListView'
        };
componentDictionary['__local__|__local__|modules|krannich-c-search-result-container|components|custom|productTileView'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-productTileView' */
                'partner/modules/krannich-c-search-result-container/components/custom/productTileView.component.tsx'),
            cn: '__local__-__local__-productTileView'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|addtocart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-addtocart' */
                'partner/themes/krannich/views/components/addtocart.component.tsx'),
            cn: '__local__-__local__-addtocart'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-carticon' */
                'partner/themes/krannich/views/components/carticon.component.tsx'),
            cn: '__local__-__local__-carticon'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartlineitem' */
                'partner/themes/krannich/views/components/cartlineitem.component.tsx'),
            cn: '__local__-__local__-cartlineitem'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|price'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-price' */
                'partner/themes/krannich/views/components/price.component.tsx'),
            cn: '__local__-__local__-price'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product' */
                'partner/themes/krannich/views/components/product.component.tsx'),
            cn: '__local__-__local__-product'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promocode' */
                'partner/themes/krannich/views/components/promocode.component.tsx'),
            cn: '__local__-__local__-promocode'
        };
componentDictionary['__local__|__local__|themes|krannich|views|components|savecarttoordertemplate'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-savecarttoordertemplate' */
                'partner/themes/krannich/views/components/savecarttoordertemplate.component.tsx'),
            cn: '__local__-__local__-savecarttoordertemplate'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product-v2'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product-v2.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-product' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
        };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
        };